import { render, staticRenderFns } from "./FTIC.vue?vue&type=template&id=044fdf50&scoped=true"
import script from "./FTIC.vue?vue&type=script&lang=js"
export * from "./FTIC.vue?vue&type=script&lang=js"
import style0 from "./FTIC.vue?vue&type=style&index=0&id=044fdf50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fdf50",
  null
  
)

export default component.exports